import React from 'react';
import { ShieldCheck } from 'lucide-react';
import './TrustPanel.css';

const POINTS = [
  'Licensed recruitment agency',
  'Thousands placed across the Gulf',
  'Support from application to arrival',
];

/** variant: 'strip' (compact, one line — mobile/end-of-list) | 'card' (sidebar, desktop). */
export default function TrustPanel({ variant = 'strip' }) {
  if (variant === 'card') {
    return (
      <div className="trust-card">
        <b>Why candidates trust ADEL</b>
        {POINTS.map((p) => (
          <div className="trust-row" key={p}>
            <ShieldCheck size={15} aria-hidden="true" /> {p}
          </div>
        ))}
        <div className="trust-flags" aria-hidden="true">🇶🇦 🇦🇪 🇸🇦 🇰🇼 🇧🇭 🇴🇲</div>
      </div>
    );
  }
  return (
    <div className="trust-strip">
      <ShieldCheck size={15} aria-hidden="true" />
      Licensed recruitment agency · Thousands placed across the Gulf
    </div>
  );
}
